import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "image-carousel" }
const _hoisted_2 = {
  ref: "sliderElm",
  class: "swiper-container image-carousel__slider"
}
const _hoisted_3 = { class: "swiper-wrapper" }
const _hoisted_4 = { class: "swiper-slide" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = {
  ref: "buttonNextElm",
  class: "swiper-button-next"
}
const _hoisted_7 = {
  ref: "buttonPrevElm",
  class: "swiper-button-prev"
}
const _hoisted_8 = {
  ref: "sliderThumbnailElm",
  class: "swiper-container image-carousel__slider-thumbnail"
}
const _hoisted_9 = { class: "swiper-wrapper" }
const _hoisted_10 = { class: "swiper-slide" }
const _hoisted_11 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.galleryImages, (image) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("img", {
              src: image.url,
              alt: image.alt
            }, null, 8, _hoisted_5)
          ]))
        }), 256))
      ]),
      _createElementVNode("div", _hoisted_6, _cache[0] || (_cache[0] = [
        _createElementVNode("i", { class: "fal fa-chevron-right" }, null, -1)
      ]), 512),
      _createElementVNode("div", _hoisted_7, _cache[1] || (_cache[1] = [
        _createElementVNode("i", { class: "fal fa-chevron-left" }, null, -1)
      ]), 512)
    ], 512),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.galleryImages, (image) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("img", {
              src: image.url,
              alt: image.alt
            }, null, 8, _hoisted_11)
          ]))
        }), 256))
      ])
    ], 512)
  ]))
}